import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from 'src/components/editor/EditTracking';

const RatingAnswerSurveyTracking: FC = () => {
  const dispatch = useDispatch();

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    .root_tracking {
      background: none;

      .close {
        width: 100%;
      }

      .center_wrapper {
        opacity: 0;
      }

      .bottom button {
        background: none;
      }

      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view root_tracking">
        <div className="template">
          <div className="center_horizon close tracking_center">
            <EditTracking
              value={tracking?.close?.[currentIndex]}
              type="close"
            />
          </div>
          <div className="center_wrapper">
            <div className="logo" />
            <div className="title" />
            <div className="sub_title" />
            <div className="star_wrapper" />
          </div>
          <div className="center_horizon bottom">
            <button className="button tracking_center">
              <EditTracking
                value={tracking?.button?.[currentIndex]}
                type="button"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RatingAnswerSurveyTracking;
